PageVue
  .fp-vertical-spacing
    .fp-vertical-spacing--line
      .fp-horizontal-spacing.-s-sm.-items-center
        .fp-horizontal-spacing--column
          button.fp-icon.fp-glyph-chevron-left.-s16.-pointer(data-test='create-exclusive.back' @click='onGoBack')
        .fp-horizontal-spacing--column
          h2.fp-title {{ t('exclusiveForm.createTitle') }}
    .fp-vertical-spacing--line(v-if='!exclusiveForm.isLoading()')
      ExclusiveFormVue#create-exclusive-form(:club-slug='clubSlug' :form-value='exclusiveForm.value()' @confirm='createExclusive' :tokens-price='club.coin.price')
  template(v-slot:footer)
    .fp-horizontal-spacing
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'goBack\')' icon='chevron-left' secondary data-test='create-exclusive.footer.back' @click='onGoBack')
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'exclusiveForm.createExclusive\')' :loading='creating' type='submit' form='create-exclusive-form' icon='plus' data-test='create-exclusive.submit')
